import { MutationTree } from 'vuex';
import { IDirectoryTree } from '../types/directory-tree';
import { IDirectoryTreeState } from './directory-tree.types';
import { EDirectoryTreeMutation } from '@/content-library/directories/tree/store/directory-tree.constants';

export const mutations: MutationTree<IDirectoryTreeState> = {
  [EDirectoryTreeMutation.SetState](state: IDirectoryTreeState, newState: IDirectoryTreeState) {
    state.loading = newState.loading;
    state.loaded = newState.loaded;
    state.tree = newState.tree;
    state.selected = newState.selected;
  },
  [EDirectoryTreeMutation.SetSelected](state: IDirectoryTreeState, selected: string) {
    state.selected = selected;
  },
  [EDirectoryTreeMutation.SetLoaded](state: IDirectoryTreeState, loaded: boolean) {
    state.loaded = loaded;
  },
  [EDirectoryTreeMutation.SetLoading](state: IDirectoryTreeState, loading: boolean) {
    state.loading = loading;
  },
  [EDirectoryTreeMutation.SetDirectoryTree](state: IDirectoryTreeState, tree: IDirectoryTree) {
    state.tree = tree;
  },
};
